//A check SkillControl runs for the organization, as the annual plan shows it (phase 20R2): set on its Integration
//(IntegrationTypes.SkillControlCheck). Such an entry is read-only here: SkillControl owns its schedule.
export class ExternalCheckScheduleState {
  skillScheduleId: string;

  name: string;

  status: string;

  nextDueAt?: Date;

  lastFiredAt?: Date;

  lastOutcome?: string;

  lastError?: string;

  consecutiveFailures: number;

  constructor() {
    this.skillScheduleId = '';
    this.name = '';
    this.status = '';
    this.consecutiveFailures = 0;
  }
}

export class ExternalCheckSchedule {
  checkKey: string;

  kind: string;

  skillId?: string;

  skillName?: string;

  publishedVersion?: string;

  //the skill's schedules page in SkillControl's web app, built by the API; absent when the address or the skill is unknown
  skillUrl?: string;

  stale: boolean;

  stateGeneratedAt?: Date;

  schedules: ExternalCheckScheduleState[];

  constructor() {
    this.checkKey = '';
    this.kind = '';
    this.stale = false;
    this.schedules = [];
  }
}
